/**
 * Abris MTL – maintain localized cart line-total displays after asynchronous
 * Shopify / third-party cart updates. This changes text only: Shopify cents,
 * cart lines, discounts, quantity controls and checkout remain untouched.
 */
(() => {
  if (window.__abrisCartLineMoneySync) return;
  window.__abrisCartLineMoneySync = true;

  const currencyCode = document.currentScript?.dataset.currencyCode || 'CAD';
  if (currencyCode !== 'CAD') return;

  const locale = (document.documentElement.lang || 'fr').toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA';
  const formatWhole = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  const formatWithCents = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const readCents = (label) => {
    const normalized = String(label || '').replace(/[\u00a0\u202f]/g, ' ').trim();
    if (!normalized.includes('$')) return null;
    const match = normalized.match(/^(-)?\s*(?:CAD\s*)?\$?\s*([\d\s.,]+)\s*\$?\s*(?:CAD)?$/i);
    if (!match) return null;

    const unsigned = match[2].replace(/\s/g, '');
    const decimalMatch = unsigned.match(/[.,](\d{1,2})$/);
    const digits = (decimalMatch ? unsigned.slice(0, -decimalMatch[0].length) : unsigned).replace(/[.,]/g, '');
    if (!/^\d+$/.test(digits)) return null;

    const major = Number(digits);
    const minor = decimalMatch ? Number(decimalMatch[1].padEnd(2, '0')) : 0;
    const cents = (major * 100 + minor) * (match[1] ? -1 : 1);
    return Number.isSafeInteger(cents) ? cents : null;
  };

  const normalizeLinePrice = (component) => {
    if (!component.isConnected) return;
    const label = component.querySelector('.transcy-money') || component;
    const original = label.textContent.trim();
    const cents = readCents(original);
    if (cents === null) return;

    let display = (cents % 100 ? formatWithCents : formatWhole).format(cents / 100);
    if (/\bCAD\b/i.test(original)) display += ' CAD';

    if (original !== display) label.textContent = display;
    if (component.hasAttribute('value') && component.getAttribute('value') !== display) {
      component.setAttribute('value', display);
    }
  };

  const refresh = () => {
    document.querySelectorAll('.cart-items__price > text-component').forEach(normalizeLinePrice);
  };

  const start = () => {
    // Drawer exists on every storefront page; the full cart has its own items component.
    const drawer = document.getElementById('cart-drawer');
    const main = document.querySelector('#MainContent');
    const roots = [drawer];
    if (main?.querySelector('cart-items-component:not([data-drawer])')) roots.push(main);
    if (!roots.some(Boolean)) return;

    let frame = 0;
    const queue = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        refresh();
      });
    };
    const observer = new MutationObserver(queue);
    for (const root of roots) {
      if (!root) continue;
      observer.observe(root, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['value']
      });
    }
    refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
